import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const RP1: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M 8.6638791,32.82607 C 8.0195739,26.446004 7.8972417,16.529055 7.874824,11.31609 c -0.00499,-1.159573 1.1061088,-2.010551 2.232088,-1.8632073 2.438671,0.3191147 5.470107,0.212462 8.072571,-0.3085003 2.975572,-0.5956605 6.716784,-2.2087546 8.88906,-3.4515863 0.597127,-0.3416817 1.33524,-0.341688 1.932524,-1.321e-4 2.173368,1.2428524 5.918458,2.856026 8.894122,3.4517184 2.598352,0.5201347 5.58274,0.6272808 7.998356,0.310028 1.125863,-0.1478688 2.236616,0.7021066 2.231631,1.8616796 -0.02228,5.212965 -0.144725,15.129914 -0.789055,21.50998 C 46.574173,40.371484 34.797233,50.106606 28.000143,50.563484 21.202896,50.106606 9.4258571,40.371484 8.6638791,32.82607 Z"
        fill={props.htmlColor || 'black'}
      />
    </SvgIcon>
  );
};

export default RP1;
